import { ItemMappingCreatePage } from "@/features/item-mapping/pages/ItemMappingCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/item-mapping/create")({
	component: ItemMappingCreatePage,
});
